import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import AdminApi from './../../../../api/admin-api/admin-api'
import { WebsiteInfoStore } from './../../stores'
import { MDBBtn, MDBRow, MDBCol, MDBCollapse } from 'mdb-react-ui-kit'
import CustomAlert from '../../../../components/shared/CustomAlert'
import TextEditor from '../../../../components/shared/TextEditor/TextEditor.component'
import ContentHtml from './../../../../components/content/ContentHtml/ContentHtml.component'
import { phoneToStorage } from './../../../../shared/formatters/telephone.formatter'
import isFlagOn from './../../../../shared/utilities/isFlagOn.function'

import './WebsiteInfoForm.component.scss'

const saveTimer = {}

const normalizeSAbout = str => {
  if (typeof str !== 'string') return str
  return str
    .replace(/\u200B|\u200C|\u200D|\u200E|\u200F|\uFEFF/g, '')
    .replace(/\u00A0/g, ' ')
    .replace(/\u2010|\u2011|\u2012|\u2013|\u2014|\u2015|\u2212/g, '-')
    .replace(/\u2018|\u2019|\u2032/g, "'")
    .replace(/\u201C|\u201D|\u2033/g, '"')
    .replace(/\u2039|\u203A/g, "'")
    .replace(/\u00AB|\u00BB/g, '"')
    .replace(/\u2026/g, '...')
    .replace(/\u2022/g, '*')
    .replace(/\u2027/g, '-')
    .replace(/\u2122/g, '(TM)')
    .replace(/\u00A9/g, '(c)')
    .replace(/\u00AE/g, '(R)')
}

const WebsiteInfoForm = ({ s_agent_picture }) => {
  const [formError, setFormError] = useState(null),
    [formSuccess, setFormSuccess] = useState(null)

  const onSelectChange = event => (WebsiteInfoStore.siteDetails[event.target.name] = event.target.value)

  const validate = () => {
    const { siteDetails } = WebsiteInfoStore,
      regHttpLink = /^(http(s)?:\/\/).*/i

    if (
      siteDetails.s_web_confrence_link &&
      siteDetails.s_web_confrence_link.trim() &&
      !regHttpLink.test(siteDetails.s_web_confrence_link)
    ) {
      const { s_web_confrence_link } = siteDetails
      WebsiteInfoStore.siteDetails.s_web_confrence_link = `http://${s_web_confrence_link}`
    }

    if (siteDetails.rx_card_link && siteDetails.rx_card_link.trim() && !regHttpLink.test(siteDetails.rx_card_link)) {
      const { rx_card_link } = siteDetails
      WebsiteInfoStore.siteDetails.rx_card_link = `http://${rx_card_link}`
    }

    // if (!siteDetails?.s_about || !siteDetails.s_about.trim()) {
    //   setFormError('About Info Required')
    //   return false
    // }

    setFormError(null)
    return true
  }

  const updateInfo = async () => {
    if (!(await validate())) return false

    if (WebsiteInfoStore.isLoading || WebsiteInfoStore.isSaving) return

    const data = {
      s_agent_picture: WebsiteInfoStore.siteDetails?.s_agent_picture ? 1 : 0,
      s_fulladdress: WebsiteInfoStore.siteDetails?.s_fulladdress ? 1 : 0,
      s_state_license_show: WebsiteInfoStore.siteDetails?.s_state_license_show ? 1 : 0,
      s_mobile_phone_show: WebsiteInfoStore.siteDetails?.s_mobile_phone_show ? 1 : 0,
      // Theme selector removed from the UI; preserve any existing value
      // (default keeps the legacy banner image valid if still referenced).
      theme_name: WebsiteInfoStore.siteDetails?.theme_name || 'premiere-default',
      s_email_override: WebsiteInfoStore.siteDetails?.s_email_override
        ? WebsiteInfoStore.siteDetails.s_email_override
        : '',
      s_phone_override: WebsiteInfoStore.siteDetails?.s_phone_override
        ? phoneToStorage(WebsiteInfoStore.siteDetails.s_phone_override)
        : '',
      s_web_confrence_link: WebsiteInfoStore.siteDetails?.s_web_confrence_link
        ? WebsiteInfoStore.siteDetails.s_web_confrence_link
        : '',
      rx_card_link: WebsiteInfoStore.siteDetails?.rx_card_link ? WebsiteInfoStore.siteDetails.rx_card_link : '',
      s_about: normalizeSAbout(WebsiteInfoStore.siteDetails?.s_about || ''),
      id: WebsiteInfoStore.siteDetails?.site_id,
    }

    let form_data = new FormData()
    for (let key in data) form_data.append(key, data[key])

    WebsiteInfoStore.isSaving = true

    AdminApi.updateWebsiteInfo(form_data)
      .then(result => {
        setFormSuccess('Successfully updated website info.')

        if (saveTimer.timer) {
          window.clearTimeout(saveTimer.timer)
          saveTimer.timer = null
        }

        saveTimer.timer = setTimeout(() => setFormSuccess(null), 4000)

        WebsiteInfoStore.isSaving = false
      })
      .catch(error => {
        setFormError(error)
        WebsiteInfoStore.isSaving = false
      })
  }

  return (
    <form id='WebsiteInfoFormComponent' noValidate className='container-fluid mt-5'>
      <MDBRow>
        <MDBCol size='12'>
          <h5 className='mb-4 text--blue font--lato fw--500'>Agent Subsite Configuration</h5>
        </MDBCol>
        <MDBCol size='12'>
          <MDBRow>
            <MDBCol size='12' lg='4' sm='12'>
              <div
                className={`alert check-wrapper ${
                  isFlagOn(WebsiteInfoStore.siteDetails?.s_agent_picture) ? 'alert-success' : 'alert-info'
                }`}
                style={{ padding: '2px', fontSize: '14px' }}
              >
                <input
                  className='form-check-input'
                  type='checkbox'
                  checked={isFlagOn(WebsiteInfoStore.siteDetails?.s_agent_picture)}
                  onChange={e => {
                    WebsiteInfoStore.siteDetails.s_agent_picture = !isFlagOn(
                      WebsiteInfoStore.siteDetails?.s_agent_picture
                    )
                  }}
                  id='s_agent_picture'
                />
                <label className='form-check-label' htmlFor='s_agent_picture'>
                  Include My Agent Photo
                </label>
              </div>
            </MDBCol>
            <MDBCol size='12' lg='4' sm='12'>
              <div
                className={`alert check-wrapper ${
                  isFlagOn(WebsiteInfoStore.siteDetails?.s_fulladdress) ? 'alert-success' : 'alert-info'
                }`}
                style={{ padding: '2px', fontSize: '14px' }}
              >
                <input
                  className='form-check-input'
                  type='checkbox'
                  checked={isFlagOn(WebsiteInfoStore.siteDetails?.s_fulladdress)}
                  onChange={e => {
                    WebsiteInfoStore.siteDetails.s_fulladdress = !isFlagOn(WebsiteInfoStore.siteDetails?.s_fulladdress)
                  }}
                  id='s_fulladdress'
                />
                <label className='form-check-label' htmlFor='s_fulladdress'>
                  Include My Full Address
                </label>
              </div>
            </MDBCol>
            <MDBCol size='12' lg='4' sm='12'>
              <div
                className={`alert check-wrapper ${
                  isFlagOn(WebsiteInfoStore.siteDetails?.s_state_license_show) ? 'alert-success' : 'alert-info'
                }`}
                style={{ padding: '2px', fontSize: '14px' }}
              >
                <input
                  className='form-check-input'
                  type='checkbox'
                  checked={isFlagOn(WebsiteInfoStore.siteDetails?.s_state_license_show)}
                  onChange={e => {
                    WebsiteInfoStore.siteDetails.s_state_license_show = !isFlagOn(
                      WebsiteInfoStore.siteDetails?.s_state_license_show
                    )
                  }}
                  id='s_state_license_show'
                />
                <label className='form-check-label' htmlFor='s_state_license_show'>
                  Show State License
                </label>
              </div>
            </MDBCol>
            <MDBCol size='12' lg='4' sm='12'>
              <div
                className={`alert check-wrapper ${
                  isFlagOn(WebsiteInfoStore.siteDetails?.s_mobile_phone_show) ? 'alert-success' : 'alert-info'
                }`}
                style={{ padding: '2px', fontSize: '14px' }}
              >
                <input
                  className='form-check-input'
                  type='checkbox'
                  checked={isFlagOn(WebsiteInfoStore.siteDetails?.s_mobile_phone_show)}
                  onChange={e => {
                    WebsiteInfoStore.siteDetails.s_mobile_phone_show = !isFlagOn(
                      WebsiteInfoStore.siteDetails?.s_mobile_phone_show
                    )
                  }}
                  id='s_mobile_phone_show'
                />
                <label className='form-check-label' htmlFor='s_mobile_phone_show'>
                  Show Mobile Phone Number
                </label>
              </div>
            </MDBCol>
          </MDBRow>
        </MDBCol>
      </MDBRow>
      <MDBRow>
        <MDBCol className='form-group' size='12' sm='6' lg='4'>
          <label>Override Public Email Address</label>
          <input
            type='text'
            className='form-control'
            name='s_email_override'
            id='s_email_override'
            value={WebsiteInfoStore.siteDetails?.s_email_override || ''}
            onChange={onSelectChange}
          />
        </MDBCol>
        <MDBCol className='form-group' size='12' sm='6' lg='4'>
          <label>Override Public Phone Number</label>
          <input
            type='text'
            className='form-control'
            name='s_phone_override'
            id='s_phone_override'
            value={WebsiteInfoStore.siteDetails?.s_phone_override || ''}
            onChange={onSelectChange}
          />
        </MDBCol>
        <MDBCol className='form-group' size='12' sm='6' lg='6'>
          <label>Web Conference Link</label>
          <ContentHtml
            contentSlug='subsite-howto-web-conference-link'
            editor={{ iconStyle: { transform: 'translateY(-20px)' } }}
          />
          <input
            type='text'
            className='form-control'
            name='s_web_confrence_link'
            id='s_web_confrence_link'
            value={WebsiteInfoStore.siteDetails?.s_web_confrence_link || ''}
            onChange={onSelectChange}
          />
        </MDBCol>
        <MDBCol className='form-group' size='12' sm='6' lg='6'>
          <label>Rx Card Link</label>
          <ContentHtml
            contentSlug='subsite-howto-rx-card-link'
            editor={{ iconStyle: { transform: 'translateY(-20px)' } }}
          />
          <input
            type='text'
            className='form-control'
            name='rx_card_link'
            id='rx_card_link'
            value={WebsiteInfoStore.siteDetails?.rx_card_link || ''}
            onChange={onSelectChange}
          />
        </MDBCol>
      </MDBRow>
      <MDBRow>
        <MDBCol className='form-group' size='12'>
          <label className='d-block'>About Content</label>
          <TextEditor
            id='websiteinfo'
            value={WebsiteInfoStore.siteDetails?.s_about}
            onChange={html => {
              if (WebsiteInfoStore.siteDetails) {
                WebsiteInfoStore.siteDetails.s_about = html
              }
            }}
          />
        </MDBCol>
      </MDBRow>
      <MDBRow>
        <MDBCol className='form-group'>
          <MDBBtn color='indigo' type='button' onClick={updateInfo}>
            {WebsiteInfoStore.isSaving ? 'Saving...' : 'Save'}
          </MDBBtn>
        </MDBCol>
      </MDBRow>
      <MDBRow>
        <MDBCol>
          <MDBCollapse open={!!formError}>
            <CustomAlert color='danger'>{formError}</CustomAlert>
          </MDBCollapse>
          <MDBCollapse open={!!formSuccess}>
            <CustomAlert color='success'>{formSuccess}</CustomAlert>
          </MDBCollapse>
        </MDBCol>
      </MDBRow>
    </form>
  )
}

export default observer(WebsiteInfoForm)
